import { storage, detailPageViewCount } from '@/utils/storage'
import { region, getQuery } from '@/utils/utils'
import { uidAsyncValidator } from './utils/validators'
import { getEnv } from '@/utils/env'
import { getUvid } from '@/utils/uvid'

// 滚动到顶部
export const scrollToTop = () => {
  try {
    window.scrollTo({
      left: 0,
      top: 0,
      behavior: 'smooth',
    })
  } catch (err) {
    if (err instanceof TypeError) {
      window.scroll(0, 0)
    } else {
      throw err
    }
  }
}

// 记录页面浏览次数
export const recordPageViewCount = (gameName, isMiuiBrowser, query) => {
  const { isFromShortcut, isFromShortcut_popup } = query
  if (
    isMiuiBrowser &&
    isFromShortcut === undefined &&
    isFromShortcut_popup === undefined
  ) {
    const pageViewStorageKey = `${detailPageViewCount}_${gameName}`
    const pageViewCount = storage.get(pageViewStorageKey) * 1
    if (pageViewCount > 3) {
      storage.set(pageViewStorageKey, 1)
    } else {
      storage.set(pageViewStorageKey, pageViewCount + 1)
    }
  }
}

// coda freefire游戏校验uid
export function codaFreefireCheckUser(
  selectedSkuInfo,
  selectedPaymentInfo,
  gameName,
  uid
) {
  const { skuId, skuName } = selectedSkuInfo || {}
  const {
    channelId,
    channelName,
    channel,
    subChannel,
    channelPrice: payPrice,
  } = selectedPaymentInfo || {}
  return publicFFCheckUidFn('coda', {
    skuId,
    skuName,
    channelId,
    channelName,
    channel,
    subChannel,
    game: gameName,
    payPrice,
    country: region(),
    source: getQuery('source') || 'ns',
    uid,
  })
}

// seagm
export const seagmFreefireCheckUser = (
  selectedSkuInfo,
  selectedPaymentInfo,
  gameName,
  uid
) => {
  const { skuId } = selectedSkuInfo || {}
  return publicFFCheckUidFn('seagm', {
    game: gameName,
    skuId: skuId,
    uid,
  })
}

export const commonCheckUID = ({ gameName, uid, cpServerId = '' }) => {
  return uidAsyncValidator(uid, gameName, cpServerId, {
    showLoading: true,
    showErrorToast: true,
  })
}
// 匿名用户在使用信用卡的时候必须先登录，和游戏无关
export const checkCreditCard = (id) => {
  const uvid = getUvid()
  if (!uvid || uvid === 'anonymous') {
    const productionCreditCardMaps = {
      ru: ['10008', '10009'],
      br: ['10018'],
      fr: ['10027'],
      es: ['10027'],
      it: ['10027'],
      de: ['10027'],
      ph: ['10028'],
      my: ['10028'],
      id: ['10028'],
      th: ['10028'],
    }
    const developmentCreditCardMaps = {
      ph: ['10039'],
      my: ['10039'],
      id: ['10039'],
      th: ['10039'],
      ru: ['10134'],
      br: ['10039'],
      fr: ['10039'],
      es: ['10039'],
      it: ['10039'],
      de: ['10039'],
    }
    const env = getEnv()
    const country = region()
    if (env === 'test') {
      const maps = developmentCreditCardMaps[country] || []
      return maps.includes(id)
    } else {
      const maps = productionCreditCardMaps[country] || []
      return maps.includes(id)
    }
  }
  return false
}
